// react
import { useContext, useState } from 'react';

// i18n
import { useTranslation } from 'react-i18next';

// types
import { Entity, V2Contract } from '../../../@types';

// context
import { ContextProject } from '../../pages/Project/Project.context';

// dialogs
import { DialogActions } from '../DialogActions/DialogActions';

// forms
import { FormManageContract } from '../../forms/FormManageContract/FormManageContract';
import { FormManageContractV2 } from '../../forms/FormManageContractV2/FormManageContractV2';

// props
export interface DialogAddContractProps {
	contract?: V2Contract | null;
	entity?: Entity;
	isOpen: boolean;
	onClose: () => void;
	onSuccess?: (contractId?: number) => void;
}

export const DialogAddContract = ({
	contract,
	entity,
	isOpen,
	onClose,
	onSuccess,
}: DialogAddContractProps) => {
	// hooks
	const { t } = useTranslation();

	// context — used to switch to the unified V2 form on V2 projects.
	const { project } = useContext(ContextProject);
	const isV2 = project?.version === '2';

	// Edit mode is only used on V2 projects (the V2 listing/detail "Edit"
	// action). V1 contract edits go through DialogEditContract.
	const isEdit = Boolean(contract);

	// state
	const [isLoading, setIsLoading] = useState(false);

	return (
		<DialogActions
			actions={[
				{
					children: t('cancel'),
					onClick: onClose,
				},
				{
					children: isEdit ? t('saveContract') : t('addContract'),
					form: 'form-manage-contract',
					loading: isLoading,
					type: 'submit',
					variant: 'contained',
				},
			]}
			hasClose={true}
			isOpen={isOpen}
			onClose={onClose}
			subtitle={{ children: entity ? entity.name : undefined }}
			title={{
				children: isEdit ? t('editContract') : t('addContract'),
				variant: 'h3',
			}}>
			{isV2 ? (
				<FormManageContractV2
					contract={contract || undefined}
					entity={entity}
					onClose={onClose}
					onSuccess={onSuccess}
					setIsLoading={setIsLoading}
				/>
			) : (
				<FormManageContract
					entity={entity}
					onClose={onClose}
					onSuccess={onSuccess}
					setIsLoading={setIsLoading}
				/>
			)}
		</DialogActions>
	);
};
